/**
 * Rewardful 推荐人追踪工具
 *
 * 解决问题：页面刷新后 Rewardful 脚本可能无法恢复 referral 信息（404 错误），
 * 导致支付时推荐人 ID 丢失。通过 localStorage 持久化 referral ID 作为兜底。
 */

const STORAGE_KEY = 'rewardful_referral_id';

/**
 * 初始化 Rewardful 推荐人追踪
 * - 从 URL 的 `via` 参数提取 affiliate token 并保存
 * - 监听 Rewardful `ready` 事件，保存 referral ID
 */
export const initRewardfulTracking = () => {
  if (!__BUILD_IN__ || typeof window === 'undefined') return;

  // 1. 从 URL 的 via 参数提取 affiliate token
  try {
    const params = new URLSearchParams(window.location.search);
    const via = params.get('via');
    if (via) {
      localStorage.setItem(STORAGE_KEY, via);
    }
  } catch {
    // ignore
  }

  // 2. 监听 Rewardful ready 事件，获取实际的 referral ID
  try {
    const rw = (window as any).rewardful;
    if (typeof rw === 'function') {
      rw('ready', () => {
        const referral = (window as any).Rewardful?.referral;
        if (referral) {
          localStorage.setItem(STORAGE_KEY, referral);
        }
      });
    }
  } catch {
    // ignore
  }
};

/**
 * 获取 Rewardful 推荐人 ID
 * 优先从 Rewardful 全局对象获取，其次从 localStorage 获取
 */
export const getRewardfulReferralId = (): string | undefined => {
  if (!__BUILD_IN__ || typeof window === 'undefined') return undefined;

  // 优先从 Rewardful 全局对象获取（最新值）
  try {
    const rw = (window as any).Rewardful;
    if (rw?.referral) {
      // 同步更新 localStorage
      localStorage.setItem(STORAGE_KEY, rw.referral);
      return rw.referral;
    }
  } catch {
    // ignore
  }

  // 从 localStorage 获取（兜底）
  try {
    return localStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
};
